import { render } from "./SetPriorityOrder.vue?vue&type=template&id=bf2e9f6c&scoped=true"
import script from "./SetPriorityOrder.vue?vue&type=script&lang=js"
export * from "./SetPriorityOrder.vue?vue&type=script&lang=js"

import "./SetPriorityOrder.vue?vue&type=style&index=0&id=bf2e9f6c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf2e9f6c"]])

export default __exports__